module.exports = __webpack_public_path__ + "static/img/cloud-lock.35c7a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-lock.png
// module id = Eo61
// module chunks = 0